import React from 'react'
import { Formik } from 'formik'
import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import { useTranslation } from 'react-i18next'
import InputTextarea from '../../views/widgets/InputTextarea'
import ContributorActionPanel from './ContributorActionPanel'
import ContributorItemImage from '../contributor-item/ContributorItemImage'

export default function ContributorForm({
  initialValues,
  language = 'th',
  isEditing,
  onValidate,
  onSubmit,
  onDelete,
}) {
  const { t } = useTranslation()
  return (
    <Formik
      enableReinitialize={true}
      validateOnChange={true}
      isInitialValid={false}
      initialValues={initialValues}
      validate={onValidate}
      onSubmit={onSubmit}
    >
      {({
        handleChange,
        handleBlur,
        values,
        errors,
        handleSubmit,
        setFieldValue,
      }) => (
        <React.Fragment>
          <ContributorActionPanel
            contributorID={values._id}
            onDelete={onDelete}
            onSubmit={handleSubmit}
            isEditing={isEditing}
          />
          <Field label={`${t('picture.label')}[${language}]`}>
            <ContributorItemImage
              originalMainImageId={values.mainImageId}
              onImageChange={mainImageId =>
                setFieldValue('mainImageId', mainImageId)
              }
            />
          </Field>
          <Field label={`${t('name.label')}[${language}]`}>
            <InputText
              name={`name.${language}`}
              placeholder="Enter yout name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name[language]}
              error={errors.name && errors.name[language]}
            />
          </Field>
          <Field label={`${t('position.label')}[${language}]`}>
            <InputText
              name={`position.${language}`}
              placeholder="Enter your position"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.position[language]}
              error={errors.position && errors.position[language]}
            />
          </Field>
          <Field label={`${t('contact.label')}[${language}]`}>
            <InputTextarea
              name={`contact.${language}`}
              placeholder="Enter your contact"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.contact[language]}
              error={errors.contact && errors.contact[language]}
            />
          </Field>
        </React.Fragment>
      )}
    </Formik>
  )
}



// WEBPACK FOOTER //
// ./src/components/templates/contributor-form/ContributorForm.js